export default "__VITE_ASSET__Bp1WIMZ$__"